import { DetailsPanel, SpeedChip } from '@/components/controls';
import { useOptionLookup } from '@/hooks';
import { Stack, Typography } from '@mui/material';

import { format } from 'date-fns';
import { Popup } from 'react-map-gl/maplibre';
import { VehicleEquipmentIcons } from '../VehicleEquipmentIcons';
import { Status } from './Status';

function DriverDetailsPanel({ driver }) {
  if (!driver?.code) return null;

  const force = driver.groups?.force?.[0];

  return (
    <DetailsPanel
      title="Driver"
      entries={[
        { label: 'Driver', value: driver.code },
        force && { label: 'Force', value: force },
      ].filter(Boolean)}
    />
  );
}

export function ExternalVehiclePopup({
  hoverInfo: {
    longitude,
    latitude,
    feature: { properties },
  },
}) {
  const vehicleRoles = useOptionLookup('vehicleRole');

  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      offset={16}
      closeButton={false}
    >
      <Stack spacing={0.5}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {properties.registrationNumber}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {format(new Date(properties.time), 'dd/MM HH:mm:ss')}
        </Typography>
        <Status status={properties.status} />
        <DetailsPanel
          entries={[
            { label: 'External Vehicle' },
            { label: 'Fleet #', value: properties.fleetNumber },
            {
              label: 'Role',
              value: vehicleRoles[properties.role] ?? properties.role,
            },
          ]}
        />
        <DriverDetailsPanel driver={properties.driver} />
        <Stack
          spacing={1}
          direction="row"
          sx={{ justifyContent: 'space-between', pt: 0.5 }}
        >
          {properties.ignitionOn && (
            <SpeedChip
              speedKilometresPerHour={properties.speedKilometresPerHour}
              speedLimitKilometresPerHour={
                properties.reverseGeocode?.speedLimitKilometresPerHour
              }
            />
          )}
          <VehicleEquipmentIcons properties={properties} />
        </Stack>
      </Stack>
    </Popup>
  );
}
